/* eslint-disable react/jsx-no-undef */
import { faExclamationCircle } from "@fortawesome/pro-regular-svg-icons/faExclamationCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, FormHelperText, Grid, TextField, Typography } from "@mui/material";
import { MprcConfirmDialog, MprcLink, MprcMessageBox, MprcStringToHtml, MprcTextMuted } from "components";
import { ManagedQuestionResponse, QuestionClass } from "generated/CoreApi_v1";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuestionContext, versionHasApplyed } from "views/assessment/questionBank/Home/EditQuestion/EditQuestion";

////////////////////////////////////////////////////////////////////////////////

export interface IPostValidationMainBox {
    questionText: string[] | undefined;
}

export interface IValidationFieldsMainBox {
    questionText: boolean;
}

export function validadeMainBox(dto: ManagedQuestionResponse): IValidationFieldsMainBox {
    return {
        questionText: dto.questionText != undefined && dto.questionText.length > 0,
    };
}

////////////////////////////////////////////////////////////////////////////////

interface IPros {
    questionTextRef: any;
}

/////////////////////////////////////////////////////////////////////////////////

export const EditQuestionMainbox: React.FC<IPros> = (props) => {
    const { questionTextRef } = props;
    const { viewData, postValidation, validationFields, readonly, handleUpdateRecord } = useQuestionContext();

    const { t } = useTranslation("assessment");
    const [dialog, setDialog] = useState<any>();

    const currentPostValidation = postValidation.mainBox;
    const currentValidationFields = validationFields.mainBox;

    const confirmNewVersion = () => {
        setDialog(<MprcConfirmDialog
            open
            severity="danger"
            message={<span>{t("Question.Edit.Main.ConfirmNewVersionMessage")}</span>}
            onClose={
                (result) => {
                    if (result) {
                        handleUpdateRecord("changeVersion", true);
                    }
                    setDialog(null);
                }
            }

        />);
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    const RenderNewVersionMessage = (
        <Grid container spacing={2}>
            <Grid>
                <MprcTextMuted>
                    <FontAwesomeIcon icon={faExclamationCircle} size="2x" />
                </MprcTextMuted>
            </Grid>
            <Grid size="grow">
                <Grid container direction="column" spacing={0}>
                    <Grid>
                        <Typography variant="bodyNotice">
                            <MprcTextMuted>
                                <b>{t("Question.Edit.Main.QuestionAlreadyAnswerText_L1")}</b>
                            </MprcTextMuted>
                        </Typography>
                    </Grid>
                    <Grid>
                        {
                            viewData.questionClass == QuestionClass.Evaluation
                                ?
                                <Typography variant="bodyNotice">
                                    <MprcTextMuted>
                                        {t("Question.Edit.Main.QuestionAlreadyAnswerText_L2")}
                                    </MprcTextMuted>
                                </Typography>
                                :
                                !viewData.changeVersion
                                    ?
                                    <Typography variant="caption" component="span">
                                        <MprcTextMuted>
                                            {t("Question.Edit.Main.QuestionSurvAlreadyAnswerText_L1")}<>&nbsp;</>
                                            <MprcLink onClick={confirmNewVersion}>
                                                <Typography variant="caption" component="span" color="Highlight">
                                                    {t("Question.Edit.Main.CreateNewVersionText")}
                                                </Typography>
                                            </MprcLink>
                                            <Typography variant="caption" component="span">
                                                <>&nbsp;</>{t("Question.Edit.Main.QuestionSurvAlreadyAnswerText_L2")}
                                            </Typography>
                                        </MprcTextMuted>
                                    </Typography>
                                    :
                                    <Typography variant="bodyNotice">
                                        <MprcTextMuted>
                                            {t("Question.Edit.Main.QuestionAlreadyAnswerText_L2")}
                                        </MprcTextMuted>
                                    </Typography>
                        }
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );

    return (
        <>
            {dialog}

            {
                versionHasApplyed(viewData) && readonly != true &&
                <Box mb={1}>
                    <MprcMessageBox
                        variant="notice"
                        fullWidth
                        message={RenderNewVersionMessage}
                    />
                </Box>
            }
            <Box paddingY={1} sx={
                (theme) => ({
                    backgroundColor: theme.palette.notice.main,
                    borderRadius: "6px"
                })
            }>
                <TextField
                    name="questionText"
                    value={viewData?.questionText}
                    placeholder={t("Question.Edit.QuestionTextPlaceholder")}
                    fullWidth
                    required
                    autoComplete="off"
                    margin="dense"
                    disabled={readonly}
                    inputRef={questionTextRef}
                    slotProps={{
                        input: {
                            inputProps: { maxLength: 512 }
                        }
                    }}
                    onChange={(e) => handleUpdateRecord("questionText", e.target.value)}
                    error={(viewData.questionText != null && !currentValidationFields.questionText) || !!currentPostValidation.questionText}
                    helperText={currentPostValidation?.questionText && <FormHelperText error>{<MprcStringToHtml text={currentPostValidation?.questionText} />}</FormHelperText>}
                />
            </Box>

        </>
    );
};
